import { createSlice } from '@reduxjs/toolkit'

export const headerSlice = createSlice({
	name: 'Header',
	initialState: {
		headerClass: '',
	},
	reducers: {
		showHeader: (state) => {
			state.headerClass = 'visible'
		},
		hideHeader: (state) => {
			state.headerClass = 'invisible'
		},
	},
})

export const { showHeader, hideHeader } = headerSlice.actions

export const { reducer } = headerSlice
